'use strict';

module.exports = {
    onAppInit: function ( config, callback ) {
        callback(null, require('../../package.json').config.tree);
    }
};
